import { render, staticRenderFns } from "./TabComponent.vue?vue&type=template&id=3d769e7a&scoped=true"
import script from "./TabComponent.vue?vue&type=script&lang=js"
export * from "./TabComponent.vue?vue&type=script&lang=js"
import style0 from "./TabComponent.vue?vue&type=style&index=0&id=3d769e7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d769e7a",
  null
  
)

export default component.exports